import { createFileRoute } from "@tanstack/react-router";
import { Reveal } from "@/components/marketing/reveal";
import { MarketingShell } from "@/components/marketing/site/marketing-shell";
import { FreeCoreList } from "@/components/marketing/site/quick-signup/free-core-list";
import { QuickSignupCard } from "@/components/marketing/site/quick-signup/quick-signup-card";
import { quickSignupHead } from "@/components/marketing/site/quick-signup/quick-signup-head";

/** One step, free: one organization, one community, PEOPLE Core, no card. AI employees are offered
 * inside the app; the paid cart is /subscribe. The form sits beside the headline. */
function QuickSignupPage() {
  return (
    <MarketingShell>
      <section className="relative overflow-hidden">
        <div className="mx-auto grid max-w-6xl items-start gap-10 px-4 pb-16 pt-20 md:pt-24 lg:grid-cols-[1fr_minmax(0,28rem)] lg:gap-16">
          <div className="lg:pt-6">
            <Reveal>
              <p
                className="mb-4 text-sm font-medium text-muted-foreground"
                data-testid="badge-signup"
              >
                Free to start
              </p>
            </Reveal>
            <Reveal delay={60}>
              <h1
                className="font-display text-balance text-4xl font-medium leading-[1.04] tracking-[-0.035em] md:text-5xl"
                data-testid="text-signup-title"
              >
                Run your community, <span className="text-gradient-warm">free</span>
              </h1>
            </Reveal>
            <Reveal delay={120}>
              <p className="mt-5 max-w-lg text-pretty text-lg text-muted-foreground">
                Residents, care, billing and staff in one place. No card, no setup fee.
              </p>
            </Reveal>
            <Reveal delay={160} className="mt-8 hidden lg:block">
              <FreeCoreList />
            </Reveal>
          </div>
          <Reveal delay={80}>
            <QuickSignupCard />
          </Reveal>
          <Reveal className="lg:hidden">
            <FreeCoreList />
          </Reveal>
        </div>
      </section>
    </MarketingShell>
  );
}

export const Route = createFileRoute("/v2/signup")({
  component: QuickSignupPage,
  head: quickSignupHead,
});
